import { Container } from '#~/device/discovery/components/selector/index.js';
import { Button } from '@studio/design-system/button';
import type { T_Maybe } from '@tryiris-ai/js-types';
import { clsx } from 'cn';
import { Sel, STagNew } from '#~/stag/index.js';

type Item = {
  id: string;
  left: string;
  right?: string;
};
interface Props {
  className?: string;
  copy: {
    leftTitle: string;
    rightTitle?: string;

    noItemsCopy: string;
    info?: string;
  };
  search?: {
    found?: string;
    copy: string;
    onSearch?: () => void;
  };
  onSettings?: (item: Item) => void;
  // IP Controllers list only. Gamepad rows stay untagged.
  tagIpControllers?: boolean;
  list: Item[];
  selected: T_Maybe<Item>;
  setSelected: (selected: Item) => void;
}

export const ItemsList = ({
  className,
  copy,
  list,
  onSettings,
  tagIpControllers,
  search,
  selected,
  setSelected
}: Props) => {
  return (
    <div className={clsx('w-[350px]', className)}>
      <Container>
        <div className='flex items-center justify-between border-b-1 border-base-100 py-12 pl-18'>
          <div className='flex-1 flex-grow-[2] text-sm font-bold'>{copy.leftTitle}</div>
          <div className='flex-1 text-sm font-bold'>{copy.rightTitle}</div>
        </div>
        <div
          className={clsx('mt-12 h-[300px]', {
            ['flex items-center justify-center']: list.length === 0
          })}
        >
          {list.length === 0 ? (
            <div className='text-secondary'>{copy.noItemsCopy}</div>
          ) : (
            <div className='flex flex-col items-stretch'>
              {list.map((item) => (
                <div
                  className={clsx(
                    'flex items-center justify-between rounded-4 text-sm transition-colors duration-250',
                    {
                      ['cursor-default bg-primary']: selected?.id === item.id,
                      ['cursor-pointer']: selected?.id !== item.id,
                      'py-8': !onSettings
                    }
                  )}
                  key={item.id}
                  onClick={() => setSelected(item)}
                  {...(tagIpControllers
                    ? STagNew(Sel.AccountSettings, 'ip_controller_row', item.id)
                    : undefined)}
                >
                  <div className='flex-1 flex-grow-[2] overflow-hidden text-ellipsis whitespace-nowrap pl-18'>
                    {item.left}
                  </div>
                  <div className='flex-1'>{item.right}</div>
                  {onSettings && (
                    <Button
                      variant='secondary'
                      className='border-0'
                      onClick={() => onSettings?.(item)}
                      {...(tagIpControllers
                        ? STagNew(Sel.AccountSettings, 'ip_controller_settings', item.id)
                        : undefined)}
                    >
                      <i className='i i-mdi-settings-outline' />
                    </Button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        {search && (
          <div className='flex items-center justify-between border-t-1 border-t-base-100'>
            <div className='px-18 py-12 text-sm'>{search.found}</div>
            {search.onSearch && (
              <Button size='sm' variant='secondary' onClick={search.onSearch}>
                {search.copy}
              </Button>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};
